import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { getConfig } from '../lib.js';

const useConfig = () => {
  const theme = useTheme();
  return useMemo(() => getConfig(theme), [theme]);
};

export { useConfig };
//# sourceMappingURL=useConfig.js.map
